import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import eventsApi from '../api/events.api';
import { extractMessageFromError } from '../utils/errorUtils';

export const useReassignEvent = (eventId: number) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();

  const {
    mutateAsync: reassignEventMutate,
    isLoading: isEventReassignLoading,
    isSuccess,
  } = useMutation(
    (ownerId: number): Promise<void> => {
      return eventsApi.reassignEvent(companyId, eventId, ownerId);
    },
    {
      onError: (error: AxiosError) => {
        const errorMessage = extractMessageFromError(error);
        showToast({
          title: 'Event reassignment failed',
          description: errorMessage,
          status: 'error',
        });
      },
    },
  );

  return { reassignEventMutate, isEventReassignLoading, isSuccess };
};
